 import React from 'react'
 import "../about.css";
 
 function TopSection() {
   return (
    <div className="background-container">
    <div className="content">
      {/* Your page content goes here */}
      <p className='topHeading'>Who <span style={{color:'#F67939'}}>We Are?</span></p>
      <p className='topText'>We Craft Millet Porridge and Nourished <br/> Soups for all the savvy eaters</p>
      {/* <p className='topText'>Soups for all the savvy eaters</p> */}
    </div>
  </div>
   )
 }
 
 export default TopSection
 